package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.ActiveTimer
import fr.manyverse.app.domain.repository.TimerRepository

/**
 * Use case for pausing a timer.
 * The countdown freezes for every targeted player.
 */
class PauseTimerUseCase(
    private val timerRepository: TimerRepository
) {
    suspend operator fun invoke(
        timerId: String
    ): Result<ActiveTimer> {
        return timerRepository.pauseTimer(
            timerId = timerId
        )
    }
}
